

import Proposal from "@/domain/proposal/Proposal";
import {defineComponent, onBeforeMount, ref, reactive} from "vue";
import BFormSelectOption from "@/components/bootstrap-library/BFormSelectOption.vue";
import CheckboxInput from "@/views/core/components/inputs/CheckboxInput.vue";
import ComboBoxInput from "@/views/core/components/inputs/ComboBoxInput.vue";
import SelectInput from "@/views/core/components/inputs/SelectInput.vue";
import TextInput from "@/views/core/components/inputs/TextInput.vue";
import BButton from "@/components/bootstrap-library/BButton.vue";
import rootStore from "@/store/RootStore";
import SaveFilterPrompt from "@/components/filters/SaveFilterPrompt.vue";
import BModal from "@/components/bootstrap-library/BModal.vue";
import ShareFilterPrompt from "@/components/filters/ShareFilterPrompt.vue";
import OrderableAdvancedTable from "@/views/core/components/OrderableAdvancedTable.vue";
import router from "@/router";
import AdvancedSearch from "@/views/search/AdvancedSearch.vue";

type State = {
  tab: string;
  searchValueOneProposal: string;
}

export default defineComponent({
  name: "AdvancedSearchScreen",
  props: {
    actionName: {
      type: String,
      default: 'Select'
    }
  },
  components: {
    AdvancedSearch, OrderableAdvancedTable, ShareFilterPrompt, SaveFilterPrompt,
    CheckboxInput, BFormSelectOption, BButton, TextInput, SelectInput, ComboBoxInput,
    BModal},
  emits: ['select'],
  setup(props, context) {
    const showSavePrompt = ref(false);
    const showSharePrompt = ref(false);
    const appConfigStore = rootStore.getInstance().appConfigStore;
    const version = appConfigStore.getVersion();
    const openNewTab = ref(false);

    const state = reactive<State>({
      searchValueOneProposal: '',
      tab: 'multiple'
    })

    onBeforeMount(() => {
      let searchTab = sessionStorage.getItem('search-tab');
      let openInNewTab = localStorage.getItem('open-in-new-tab');

      if (searchTab) {
        state.tab = searchTab;
      } else {
        state.tab = 'multiple';
      }

      if (openInNewTab) {
        openNewTab.value = openInNewTab === "true" ? true : false;
      }
    })

    function displayTab(tab: string) {
      sessionStorage.setItem('search-tab', tab);
      state.tab = tab;
    }

    function handleSearchProposal() {
      router.push({name: 'Proposal', params: {proposalNumber: state.searchValueOneProposal}});
    }

    function emitSelection(proposal: Proposal) {
      const routeData = router.resolve({
        name: 'Proposal', params: {proposalNumber: proposal.proposalNumber}
      });
      if (openNewTab.value) {
        window.open(routeData.href, '_blank');
      } else {
        router.push(routeData);
      }
    }

    function saveOpenPreference() {
      localStorage.setItem("open-in-new-tab", openNewTab.value.toString());
    }

    return {
      state,
      version,
      emitSelection,
      showSavePrompt,
      showSharePrompt,
      displayTab,
      handleSearchProposal,
      openNewTab,
      saveOpenPreference,
    }
  }
})
